import { render } from "./SobrePage2.vue?vue&type=template&id=84f0cdf2&scoped=true"
import script from "./SobrePage2.vue?vue&type=script&lang=js"
export * from "./SobrePage2.vue?vue&type=script&lang=js"

import "./SobrePage2.vue?vue&type=style&index=0&id=84f0cdf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f0cdf2"]])

export default __exports__